"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrency = getCurrency;
exports.getCurrencySymbol = getCurrencySymbol;
exports["default"] = void 0;

var _AppStore = _interopRequireDefault(require("../logic/store/AppStore"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getCurrency() {
  var state = _AppStore["default"].getState();

  return state.auth.profile.currency;
}

function getCurrencySymbol() {
  var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!currency) {
    currency = getCurrency();
  }

  var map = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£'
  };
  return map[currency] || currency;
}

var _default = {
  getCurrency: getCurrency,
  getCurrencySymbol: getCurrencySymbol
};
exports["default"] = _default;